module.exports = __webpack_public_path__ + "img/yylogo.d08e04ab.png";